import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e7269b3e")

_pushScopeId("data-v-e7269b3e")
const _hoisted_1 = { class: "p-grid" }
const _hoisted_2 = {
  key: 0,
  class: "download-btn p-ml-auto"
}
const _hoisted_3 = {
  class: "download-btn-panel",
  style: {}
}
const _hoisted_4 = { class: "p-col-12" }
const _hoisted_5 = {
  key: 1,
  class: "p-col-6"
}
const _hoisted_6 = {
  key: 2,
  class: "p-col-12"
}
const _hoisted_7 = { class: "p-d-flex p-jc-between" }
const _hoisted_8 = { class: "p-grid p-m-0" }
const _hoisted_9 = {
  key: 0,
  class: "p-mt-1 p-mr-4 title-font"
}
const _hoisted_10 = { style: {"height":"40vh"} }
const _hoisted_11 = {
  key: 3,
  class: "p-col-12"
}
const _hoisted_12 = { class: "p-d-flex p-jc-between" }
const _hoisted_13 = {
  key: 0,
  class: "p-grid p-m-0 title-font"
}
const _hoisted_14 = { class: "p-mb-5" }
const _hoisted_15 = {
  for: "modelSelection",
  class: "p-mr-2"
}
const _hoisted_16 = {
  key: 0,
  class: "p-mb-5"
}
const _hoisted_17 = {
  for: "classSelection",
  class: "p-mr-2"
}
const _hoisted_18 = {
  for: "classSelection",
  class: "p-mr-2"
}
const _hoisted_19 = { class: "p-text-center" }
const _hoisted_20 = { class: "title-font" }
const _hoisted_21 = { style: {"height":"40vh"} }
const _hoisted_22 = { class: "p-col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_FeatureChart = _resolveComponent("FeatureChart")!
  const _component_ModelChart = _resolveComponent("ModelChart")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ChartSettingsDialog = _resolveComponent("ChartSettingsDialog")!
  const _component_Prediction = _resolveComponent("Prediction")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_EvaluationChart = _resolveComponent("EvaluationChart")!
  const _component_LeaderBoard = _resolveComponent("LeaderBoard")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (
        _ctx.experimentDetail.status === 'COMPLETED' && _ctx.downloadableModels.length
      )
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              id: "download-btn",
              type: "Button",
              icon: "bx bx-download",
              class: "p-button-outlined p-button-secondary",
              onClick: _ctx.toggle,
              "aria-haspopup": "true",
              "aria-controls": "overlay_panel",
              label: _ctx.$t('button.download.description')
            }, null, 8, ["onClick", "label"])
          ]),
          _createVNode(_component_OverlayPanel, {
            ref: "op",
            appendTo: "body",
            showCloseIcon: false,
            id: "overlay_panel"
          }, {
            default: _withId(() => [
              _createVNode(_component_DataTable, {
                value: _ctx.downloadableModels,
                selection: _ctx.selectedModelToDownload,
                "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedModelToDownload = $event)),
                selectionMode: "single",
                paginator: true,
                rows: 5,
                onRowSelect: _ctx.onModelSelect,
                responsiveLayout: "scroll"
              }, {
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    field: "name",
                    header: _ctx.$t('automl.evaluation.leaderBoard.headers.modelName'),
                    sortable: ""
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.$t(slotProps.data.name)), 1)
                    ]),
                    _: 1
                  }, 8, ["header"])
                ]),
                _: 1
              }, 8, ["value", "selection", "onRowSelect"])
            ]),
            _: 1
          }, 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Summary, {
        experiment: _ctx.experimentDetail,
        datasourceConfig: _ctx.datasourceConfig[0],
        datasourceConfigDetail: _ctx.datasourceConfigDetail,
        bestKpi: _ctx.bestKpi,
        metrics: _ctx.summaryMetrics,
        workspaceId: _ctx.workspaceId
      }, null, 8, ["experiment", "datasourceConfig", "datasourceConfigDetail", "bestKpi", "metrics", "workspaceId"])
    ]),
    _createVNode("div", {
      class: _ctx.emsembleModel ? 'p-col-6' : 'p-col-12'
    }, [
      _createVNode(_component_FeatureChart, {
        models: _ctx.models,
        experiment: _ctx.experimentDetail,
        datasourceConfig: _ctx.datasourceConfig[0]
      }, null, 8, ["models", "experiment", "datasourceConfig"])
    ], 2),
    (_ctx.emsembleModel)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_ModelChart, {
            model: _ctx.emsembleModel,
            experiment: _ctx.experimentDetail
          }, null, 8, ["model", "experiment"])
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.experimentDetail.config.predictionType === 'regression' &&
        _ctx.experimentDetail.config.splitType === 'time_series' &&
        _ctx.experimentDetail.config.timeSeries === true
      )
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.timeSeriesIdentifierCandidateOption.length)
                ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("exp.label.choose.timeseries")), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.datasourceConfig[0]?.timeSeriesIdentifiers, (value, index) => {
                return (_openBlock(), _createBlock("span", {
                  class: "p-mb-5",
                  key: index
                }, [
                  _createVNode("label", {
                    for: value,
                    class: "p-mr-2"
                  }, _toDisplayString(value), 9, ["for"]),
                  _createVNode(_component_Dropdown, {
                    id: value,
                    class: "p-mr-4",
                    modelValue: _ctx.timeSeriesIdentifierCandidateSelectedValue[index],
                    "onUpdate:modelValue": ($event: any) => (_ctx.timeSeriesIdentifierCandidateSelectedValue[index] = $event),
                    options: _ctx.timeSeriesIdentifierCandidateOption[index],
                    placeholder: _ctx.datasourceConfig[0]?.timeSeriesIdentifiers[index],
                    filter: true,
                    onFilter: ($event: any) => (_ctx.onfilterChanged(value, index, $event)),
                    optionLabel: "candidate",
                    "virtual-scroller-options": {
                itemSize: 31,
              }
                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "options", "placeholder", "onFilter"])
                ]))
              }), 128))
            ]),
            _createVNode("div", null, [
              _createVNode(_component_Button, {
                label: _ctx.$t('experiment.evaluation.chart-settings'),
                onClick: _ctx.toggleChartSettings,
                "aria-haspopup": "true",
                "aria-controls": "chartSettingsOP"
              }, null, 8, ["label", "onClick"]),
              _createVNode(_component_OverlayPanel, {
                appendTo: "body",
                showCloseIcon: false,
                ref: "chartSettingsOP",
                id: "chartSettingsOP",
                style: {"width":"450px"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_ChartSettingsDialog, {
                    "custom-chart-range": _ctx.chartSettings.customChartRange,
                    "highlight-quantile": _ctx.chartSettings.highlightQuantile,
                    "selected-chart-axis-option": 
                _ctx.chartSettings.selectedChartAxisOption
              ,
                    "show-quantile": _ctx.chartSettings.showQuantile,
                    "target-column": _ctx.datasourceConfig[0].targetColumn,
                    onSaveSettings: _ctx.onSaveChartSettings,
                    onCancelSettings: _ctx.onCancelChartSettings
                  }, null, 8, ["custom-chart-range", "highlight-quantile", "selected-chart-axis-option", "show-quantile", "target-column", "onSaveSettings", "onCancelSettings"])
                ]),
                _: 1
              }, 512)
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            (!_ctx.loadingPredictionGraphData)
              ? (_openBlock(), _createBlock(_component_Prediction, {
                  key: 0,
                  experiment: _ctx.experimentDetail,
                  models: _ctx.models,
                  "selected-chart-axis-option": _ctx.chartSettings.selectedChartAxisOption,
                  "custom-chart-range": _ctx.chartSettings.customChartRange,
                  "show-quantile": _ctx.chartSettings.showQuantile,
                  "highlight-quantile": _ctx.chartSettings.highlightQuantile,
                  currentType: _ctx.chartType,
                  "onUpdate:currentType": _cache[2] || (_cache[2] = ($event: any) => (_ctx.chartType = $event)),
                  selected: _ctx.selected,
                  "onUpdate:selected": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selected = $event)),
                  zoom: _ctx.zoom,
                  "onUpdate:zoom": _cache[4] || (_cache[4] = ($event: any) => (_ctx.zoom = $event))
                }, null, 8, ["experiment", "models", "selected-chart-axis-option", "custom-chart-range", "show-quantile", "highlight-quantile", "currentType", "selected", "zoom"]))
              : (_openBlock(), _createBlock(_component_ProgressSpinner, {
                  key: 1,
                  class: "p-d-flex p-jc-between p-ai-center",
                  style: {"height":"100%"}
                }))
          ])
        ]))
      : _createCommentVNode("", true),
    (
        !_ctx.experimentDetail.config.timeSeries &&
        (_ctx.evaluation.length || _ctx.experimentDetail.status === 'COMPLETED')
      )
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("automl.evaluation.leaderBoard.headers.choose.model")), 1),
                    _createVNode(_component_Dropdown, {
                      id: "modelSelection",
                      modelValue: _ctx.selectedModel,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedModel = $event)),
                      options: _ctx.models,
                      optionLabel: "name",
                      class: "p-mr-4",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onUpdateModel($event)))
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  (_ctx.experimentDetail.config.predictionType !== 'regression')
                    ? (_openBlock(), _createBlock("span", _hoisted_16, [
                        _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("automl.evaluation.leaderBoard.headers.class.model")), 1),
                        _createVNode("label", _hoisted_18, _toDisplayString(_ctx.datasourceConfig[0]?.targetColumn) + ":", 1),
                        _createVNode(_component_Dropdown, {
                          modelValue: _ctx.selectedEvalClass,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedEvalClass = $event)),
                          options: _ctx.evalClass,
                          optionLabel: "labelDecode",
                          class: "p-mr-4",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onUpdateEvalClass($event))),
                          id: "classSelection"
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.experimentDetail.config.predictionType === "regression"
              ? _ctx.$t("automl.label.title.regression", {
                  target: _ctx.datasourceConfig[0]?.targetColumn,
                })
              : _ctx.$t("automl.label.title.classification", {
                  model: _ctx.selectedModel ? `[${_ctx.selectedModel.name}]` : "",
                  target: _ctx.datasourceConfig[0]?.targetColumn,
                  class: _ctx.selectedEvalClass?.labelDecode,
                })), 1)
          ]),
          _createVNode("div", _hoisted_21, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_EvaluationChart, {
                  key: 0,
                  model: _ctx.selectedModel,
                  evaluation: _ctx.modelEvaluation,
                  experiment: _ctx.experimentDetail,
                  currentType: _ctx.chartType,
                  selected: _ctx.selected,
                  zoom: _ctx.zoom,
                  targetColumn: _ctx.datasourceConfig[0]?.targetColumn,
                  predictionType: _ctx.experimentDetail.config.predictionType,
                  evalClass: _ctx.selectedEvalClass?.labelDecode
                }, null, 8, ["model", "evaluation", "experiment", "currentType", "selected", "zoom", "targetColumn", "predictionType", "evalClass"]))
              : (_openBlock(), _createBlock(_component_ProgressSpinner, {
                  key: 1,
                  class: "p-d-flex p-jc-between p-ai-center",
                  style: {"height":"100%"}
                }))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_22, [
      _createVNode(_component_LeaderBoard, {
        models: _ctx.models,
        "sort-by-val": _ctx.isTrainingExperiment,
        "sort-by-test": _ctx.isCompletedExperiment
      }, null, 8, ["models", "sort-by-val", "sort-by-test"])
    ])
  ]))
})